export default function useCurrentUser() {
  const { currentUser } = window as any
  return currentUser || {}
}
